var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 10.9355C10.5158 10.9355 10.9355 10.5158 10.9355 9.99805C10.9355 9.48028 10.5158 9.06055 9.99805 9.06055C9.48028 9.06055 9.06055 9.48028 9.06055 9.99805C9.06055 10.5158 9.48028 10.9355 9.99805 10.9355Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.002 10.9355C15.5197 10.9355 15.9395 10.5158 15.9395 9.99805C15.9395 9.48028 15.5197 9.06055 15.002 9.06055C14.4842 9.06055 14.0645 9.48028 14.0645 9.99805C14.0645 10.5158 14.4842 10.9355 15.002 10.9355Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99805 10.9355C5.51581 10.9355 5.93555 10.5158 5.93555 9.99805C5.93555 9.48028 5.51581 9.06055 4.99805 9.06055C4.48028 9.06055 4.06055 9.48028 4.06055 9.99805C4.06055 10.5158 4.48028 10.9355 4.99805 10.9355Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThree);
export default __webpack_public_path__ + "static/media/dots-three.6858625e4fcc85eebf1533f1f16e2e7f.svg";
export { ForwardRef as ReactComponent };